import script from "./GroupProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupProducts.vue?vue&type=script&lang=ts&setup=true"

import "./GroupProducts.vue?vue&type=style&index=0&id=0c7c92e0&lang=scss&scoped=true"
import "./GroupProducts.vue?vue&type=style&index=1&id=0c7c92e0&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7c92e0"]])

export default __exports__